import { StickyNote } from '@akin-home/sticky-notes';
import {
  createStickyNoteMutation,
  serializeStickyNoteForPost,
} from '@akin-home/sticky-notes/frontend';
import { useMutation, useQueryClient } from 'react-query';

interface Params {
  options?: any;
}

export const useCreateStickyNoteMutation = (params?: Params) => {
  const queryClient = useQueryClient();

  return useMutation(createStickyNoteMutation, {
    onSuccess: (data) => {
      const newNote = data.data.createStickyNote;
      if (newNote) {
        queryClient.setQueriesData('sticky-notes', (notes: any) => [
          ...notes,
          newNote,
        ]);
      }
    },
  });
};

export const useCreateStickyNote = () => {
  const create = useCreateStickyNoteMutation();

  return (sticky_note: StickyNote) =>
    create.mutateAsync({ input: serializeStickyNoteForPost(sticky_note) });
};
